<template>
  <section class="clipVideoSkeleton">
    <section class="clipVideoSkeleton-main">
      <skeleton-box class="clipVideoSkeleton-header" />
      <skeleton-video show-controllers />
    </section>
  </section>
</template>
<script>
export default {
  name: 'ClipVideoSkeleton',
};
</script>

<style lang="scss">
.clipVideoSkeleton {
  margin-top: 35px;
  margin-left: 30px;
  position: absolute;
  aspect-ratio: 16/9;
  width: 65%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &-main {
    width: 100%;
    margin-right: 20px;
    & .skeleton-box.videoSkeleton-controller {
      height: 20px;
    }
  }
  &-header {
    width: 40%;
    height: 20px;
    border-radius: 15px;
  }
}
</style>
